import { Group } from "@domain/group/group";
import { Author } from "@domain/lms/content";
import { Media } from "@domain/media/media";
import { Organization } from "@domain/organization/organization";
import { OrganizationType } from "@domain/organization/organizationType";
type LivecourseOrganization = Omit<Organization, "id" | "type"> & {
	id?: string;
	type?: OrganizationType;
};
export interface Livecourse {
	id: string;
	organization: LivecourseOrganization;
	type: LivecourseType;
	title: string;
	banner?: Media;
	participationStatus?: string;
	description?: string;
	organizer: string;
	workspaceId?: string;
	organizationId?: string;
	banner_id: string | Media;
	startDate: Date;
	endDate?: Date;
	status: string;
	category?: string;
	participationLink: string;
	liveShareLink: string;
	postAutoPublish: boolean;
	start_date: string;
	end_date?: string;
	shareroom: Group;
	author?: Author;
}

export interface LiveCourseParticipant {
	participationLink?: string;
	liveShareLink?: string;
}

//export type LiveType = "INSTANT" | "SCHEDULED";
export type LiveType = "LIVE" | "PLANNED";

// change live type values
// INSTANT = LIVE
// PLANNED = SCHEDULED
export enum LivecourseType {
	INSTANT = "LIVE",
	SCHEDULED = "PLANNED",
	OVER = "OVER",
	NOT_DEFINED = "NOT_DEFINED",
}
export enum LivecourseStatus {
	STATUS = "FINISHED",
}
